<template>
    <ContentRenderer :content="question.content" v-if="question.content" :media-delay="400"></ContentRenderer>
    <v-container v-else>
          <v-row>
            <v-col class="align-center">
                <span v-if="question.header_textassetid">{{$ta(question.header_textassetid)}}</span>
                <question-item v-if="question.item_textassetid" :item="$ta(question.item_textassetid)"></question-item>
                <small v-if="question.subtitle_textassetid">{{$ta(question.subtitle_textassetid)}}</small>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import ContentRenderer from "../../../content/ContentRenderer";
  import QuestionItem from "./QuestionItem";
  export default {
    name: "QuestionContentRenderer",
    components:{
      ContentRenderer,QuestionItem
    },
    props:{
      question:{type:Object, required:true}
    }
  }
</script>

<style scoped>
.align-center{
    text-align: center;
}
</style>